module.exports = __webpack_public_path__ + "static/img/6.228734f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/6.png
// module id = j1Re
// module chunks = 0